import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fetchReleasesErrorTitle: {
		id: 'business-calendar.controllers.calendar-releases.fetch-releases-error-title',
		defaultMessage: "We couldn't fetch the releases",
		description: 'Error message informing the user that the releases could not be fetched',
	},
	fetchReleasesErrorMessage: {
		id: 'business-calendar.controllers.calendar-releases.fetch-releases-error-message',
		defaultMessage:
			"We’re having trouble surfacing the project's releases. Wait a few moments, then try again.",
		description: 'Error message when fetching releases fails',
	},
	connectedProjectNotFoundErrorTitle: {
		id: 'business-calendar.controllers.calendar-releases.connected-project-not-found-error-title',
		defaultMessage: "We couldn't find the connected software project",
		description:
			'Title for flag error message informing the user that the connected project could not be found',
	},
	connectedProjectNotFoundErrorMessage: {
		id: 'business-calendar.controllers.calendar-releases.connected-project-not-found-error-message',
		defaultMessage: 'Releases for the connected software project will no longer be displayed.',
		description:
			'Error message informing the user that the connected project was not found and releases will not be displayed',
	},
	connectedProjectNotFoundAndDisconnectedMessage: {
		id: 'business-calendar.controllers.calendar-releases.connected-project-not-found-and-disconnected-message',
		defaultMessage:
			"Your permissions may have changed or the connected software project may have been deleted. We've disconnected the project.",
		description:
			'Error message informing the user that the connected project was not found and will be disconnected',
	},
	permissionDeniedErrorTitle: {
		id: 'business-calendar.controllers.calendar-releases.permission-denied-error-title',
		defaultMessage: 'You can’t view project releases',
		description: 'Flag title for permission denied error',
	},
	permissionDeniedErrorDescription: {
		id: 'business-calendar.controllers.calendar-releases.permission-denied-error-description',

		defaultMessage: 'If you need access, ask an admin to update permissions.',
		description: 'Flag description for permission denied error',
	},
	tooManyRequestsErrorTitle: {
		id: 'business-calendar.controllers.calendar-releases.too-many-requests-error-title',
		defaultMessage: 'We got too many requests',
		description: 'Flag title explaining that the server is busy',
	},
	tooManyRequestsErrorDescription: {
		id: 'business-calendar.controllers.calendar-releases.too-many-requests-error-description',
		defaultMessage: 'Lots of requests in a short period of time. Try again in a few minutes.',
		description:
			'Flag description explaining that the server is busy and the user should try again later',
	},
});
